<template>
	<b-modal
		id="candidateUploadDocuments"
		centered
		hide-footer
		hide-header
		class="p-0"
	>
		<div class="d-flex h-100">
			<div class="w-100">
				<div class="candash-modal-top p-3">
					<div class="width-97">
						<div class="canDoc-modal-head">Upload document</div>
					</div>
					<div
						class="d-flex justify-content-end pointer rotate-on-hover"
						@click="closeModel()"
					>
						<img
							src="../../assets/candidate-documents/docs-x-close.svg"
							alt=""
						/>
					</div>
				</div>
				<div class="candash-modal-body px-5-query">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="w-96">
							<div class="canDoc-modal-label">
								Document Name<span class="asterik"> * </span>
							</div>
							<div class="doc-modal-fields w-100 mt-1">
								<b-form-input
									:class="{
										errorfields: $v.defineDocName.$error,
									}"
									v-model.trim="$v.defineDocName.$model"
									placeholder="Enter"
									type="text"
									:disabled="!otherModal"
								/>
								<div
									v-if="!$v.defineDocName.required && $v.defineDocName.$dirty"
									class="err-txt-uploadfail mt-1"
								>
									Required
								</div>
								<div
									v-else-if="
										$v.defineDocName.$dirty && !$v.defineDocName.maxLength
									"
									class="err-txt-uploadfail mt-1"
								>
									Document name should not exceed 128 characters
								</div>
							</div>
						</div>
						<div class="w-96 my-4">
							<div class="canDoc-modal-label">
								Document<span class="asterik"> * </span>
							</div>

							<div
								v-if="
									!fileDetails.present &&
									!fileDetails.size &&
									!filetype &&
									!notUpload
								"
							>
								<div
									id="laptop-upload"
									class="candDocs-uploadFile mt-1 d-flex align-items-center justify-content-center position-relative"
									v-b-tooltip.hover="'(.pdf) max 10 mb'"
								>
									<b-form-file
										class="mb-2 pointer"
										accept="application/pdf"
										@change="checkFile"
										ref="uploadFiles"
									>
									</b-form-file>
									<img
										class="mr-2"
										src="../../assets/candidate-documents/dragAndDrop.svg"
										alt=""
									/>
									<div>
										<span class="dragndrop-txt">Drag & Drop or </span>
										<span class="browsefile-txt white-space-no-wrap"
											>Browse File</span
										>
									</div>
								</div>
								<div
									id="mobile-upload"
									class="candDocs-uploadFile d-flex align-items-center justify-content-between px-2"
								>
									<div>
										<div class="asp-small-grey-txt-2">Upload File</div>
										<div class="mobjd-light-txt mt-1">(.pdf) max 10 mb</div>
									</div>
									<div class="d-flex align-items-center">
										<div class="asp-vertical-line mr-2"></div>
										<div class="ucdSelDocFile position-relative">
											<b-form-file
												class="mb-2 pointer"
												accept="application/pdf"
												@change="checkFile"
												ref="uploadFiles"
											>
											</b-form-file>
											<img
												src="../../assets/newdesign/jdprogress/mobjdprog/upload.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>

							<div v-if="fileDetails.size || filetype || notUpload">
								<div
									id="laptop-upload"
									class="candDocs-uploadFile candDocs-uploadFile-err mt-1 d-flex align-items-center justify-content-center position-relative"
								>
									<b-form-file
										class="mb-2 pointer"
										accept="application/pdf"
										@change="checkFile"
										ref="uploadFiles"
									>
									</b-form-file>
									<img
										class="mr-2"
										src="../../assets/candidate-documents/dragAndDrop.svg"
										alt=""
									/>
									<div>
										<span class="dragndrop-txt">Drag & Drop or </span>
										<span class="browsefile-txt white-space-no-wrap"
											>Browse File</span
										>
									</div>
									<div
										v-if="fileDetails.size"
										class="err-txt-uploadfail laptop-error-pos"
									>
										File limit exceeded.
									</div>
									<div
										v-else-if="notUpload"
										class="err-txt-uploadfail laptop-error-pos"
									>
										Required
									</div>
									<div v-else class="err-txt-uploadfail laptop-error-pos">
										Failed
									</div>
								</div>
								<div id="mobile-upload">
									<div
										class="candDocs-uploadFile candDocs-uploadFile-err d-flex align-items-center justify-content-between px-2"
									>
										<div>
											<div class="asp-small-grey-txt-2">Upload File</div>
											<div class="mobjd-light-txt mt-1">(.pdf) max 10 mb</div>
										</div>
										<div class="d-flex align-items-center">
											<div class="asp-vertical-line mr-2"></div>
											<div class="ucdSelDocFile position-relative">
												<b-form-file
													class="mb-2 pointer"
													accept="application/pdf"
													@change="checkFile"
													ref="uploadFiles"
												>
												</b-form-file>
												<img
													src="../../assets/newdesign/jdprogress/mobjdprog/upload.svg"
													alt=""
												/>
											</div>
										</div>
									</div>
									<div v-if="fileDetails.size" class="err-txt-uploadfail mt-1">
										File limit exceeded.
									</div>
									<div v-else-if="notUpload" class="err-txt-uploadfail mt-1">
										Required
									</div>
									<div v-else class="err-txt-uploadfail mt-1">Failed</div>
								</div>
							</div>

							<!-- when we select some file this div will get displayed -->
							<div v-else-if="fileDetails.present && !fileDetails.size">
								<div
									id="laptop-upload"
									class="uploaded-box d-flex align-items-center justify-content-center mt-1"
								>
									<div class="d-flex justify-content-between px-3 w-100">
										<!-- {{ fileDetails}} -->
										<div class="d-flex align-items-center w-75">
											<img
												src="../../assets/candidate-documents/uploaded-doc.svg"
												alt=""
											/>
											<div class="ml-1 mr-3 uploadedFile-font text-truncate">
												{{ fileDetails.fileName }}
											</div>
										</div>
										<div class="d-flex justifiy-content-between">
											<div
												ref="replacedocdum"
												class="mr-2 ucdSelDocFile position-relative"
											>
												<b-form-file
													class="mb-2 pointer"
													accept="application/pdf"
													@change="checkFile"
												>
												</b-form-file>
												<img
													style="height: 22px; width: 22px"
													class="pointer"
													src="../../assets/candidate-documents/replace-uld.svg"
													alt=""
												/>
											</div>
											<div>
												<img
													@click="removeFile"
													class="pointer"
													src="../../assets/candidate-documents/docs-x-close.svg"
													alt=""
												/>
											</div>
										</div>
									</div>
								</div>

								<div
									id="mobile-upload"
									class="d-flex align-items-center uploaded-box justify-content-between px-2"
								>
									<div class="d-flex w-75">
										<div>
											<img
												src="../../assets/icons/mobUpldDoc/doc-uploaded.svg"
											/>
										</div>
										<div
											class="asp-small-grey-txt-2 ml-1 mt-1 w-75 text-truncate"
										>
											{{ fileDetails.fileName }}
										</div>
									</div>
									<div class="d-flex justify-content-between">
										<div
											ref="replacedocdum"
											class="ucdSelDocFile position-relative"
										>
											<b-form-file
												class="mb-2 pointer"
												accept="application/pdf"
												@change="checkFile"
											>
											</b-form-file>
											<img
												style="height: 22px; width: 22px"
												class="pointer"
												src="../../assets/candidate-documents/replace-uld.svg"
												alt=""
											/>
										</div>
										<img
											class="mx-2"
											src="../../assets/icons/mobUpldDoc/card-line.svg"
											alt=""
										/>

										<img
											@click="removeFile"
											src="../../assets/icons/mobUpldDoc/delete-mob.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					:class="!isLaptop ? 'justify-content-center' : 'justify-content-end'"
					class="candash-modal-footer d-flex align-items-center gap-3"
				>
					<div>
						<b-button
							:disabled="buttonLoader"
							class="uploadDocs-cancelbtn"
							:class="!isLaptop ? 'btn-sizes-web ' : ''"
							@click="closeModel()"
							>Cancel</b-button
						>
					</div>
					<div class="uploadDocs-btn position-relative">
						<!-- :class="
              buttonLoader ? ' loader-class-doc defaultCursor' : ' pointer'
            " -->
						<b-button
							:class="{
								'upload-loader-class-doc defaultCursor': buttonLoader,
								pointer: !buttonLoader,
								'btn-sizes-web mr-0': !isLaptop,
							}"
							@click="
								buttonLoader ? '' : otherModal ? uploadDocs() : replaceDocs()
							"
							>{{ buttonLoader ? "" : "Upload" }}</b-button
						>
						<div v-if="buttonLoader" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { maxLength, required } from "vuelidate/lib/validators";

import { postDocument, putDocument } from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast";
import Loader from "../../components/fixedcomponents/Loader.vue";

export default {
	components: {
		Loader,
	},
	mixins: [toast],
	data() {
		return {
			notUpload: false,
			errorvar: true,
			filetype: false,
			isLaptop: true,
			fileDetails: {
				file: "",
				fileName: "",
				present: false,
				flag: true,
				size: false,
				sourceKey: 0,
			},
			buttonLoader: false,
		};
	},
	props: {
		otherModal: Boolean,
		defineDocName: String,
		categoryID: String,
		defineDocReferenceID: String,
		documentID: String,
	},
	mounted() {
		window.addEventListener("resize", this.checkScreenSize);
		this.checkScreenSize();
		const fileTag = this.$refs.uploadFiles.$el;
		fileTag.addEventListener("drop", this.handleDrop);
	},
	beforeDestroy() {
		const fileTag = this.$refs.uploadFiles.$el;
		fileTag.removeEventListener("drop", this.handleDrop);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	validations() {
		return {
			defineDocName: {
				required,
				maxLength: maxLength(128),
			},
		};
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		closeModel() {
			this.notUpload = false;
			this.filetype = false;
			if (this.otherModal) {
				this.defineDocName = "";
			}
			this.$bvModal.hide("candidateUploadDocuments");
			this.removeFile();
			this.$v.$reset();
		},
		async replaceDocs() {
			try {
				if (!this.fileDetails.present) {
					this.notUpload = true;
					this.errorModal("Error", "Please fill all the required fields");
				} else {
					this.buttonLoader = true;

					this.loading = true;
					var form = new FormData();
					let source = {
						sourceKeys: ["key"],
					};
					// form.append("documentName", this.document);
					form.append("source", JSON.stringify(source));
					form.append("key", this.sourceKey);
					form.append("documentID", this.documentID);
					const response = await putDocument(form);
					if (response.status == 200) {
						this.buttonLoader = false;

						this.notUpload = false;
						this.loading = false;
						this.$bvModal.hide("candidateUploadDocuments");
						this.successModal("Success", "Document replaced sucessfully!");

						this.$emit("updateDoc");
						this.fileDetails = {
							file: "",
							fileName: "",
							present: false,
							flag: true,
						};
						this.document = "";
					}
				}
			} catch (error) {
				this.buttonLoader = false;
				this.loading = false;
				throw error;
			}
		},
		removeFile() {
			this.fileDetails.present = false;
			this.fileDetails.flag = true;
			this.fileDetails.fileName = "";
			this.fileDetails.size = false;
			this.fileDetails.file = "";
		},
		checkFile(event) {
			var input = event.target;
			const file = input.files[0];
			if (!file.type.includes("pdf")) {
				this.filetype = true;
				this.errorModal("Error", "Please upload a file in PDF format.");
			}
			var pdfcheck = input.files[0];

			if (!pdfcheck.type.includes("pdf")) {
				this.notUpload = false;
				this.filetype = true;
				this.fileDetails.flag = false;
				this.fileDetails.present = false;
				this.fileDetails.fileName = "";
				this.fileDetails.file = "";
				this.fileDetails.size = false;
				event.target.value = "";
			} else {
				if (input.files && input.files[0]) {
					const size = input.files[0].size;
					const fileSizeInMb = size / (1024 * 1024);
					if (fileSizeInMb > 10) {
						this.fileDetails.size = true;
						this.fileDetails.file = "";
						this.fileDetails.present = false;
						this.fileDetails.fileName = "";
						return;
					}
					this.notUpload = false;
					this.filetype = false;
					this.fileDetails.size = false;
					this.fileDetails.fileName = input.files[0].name;
					var reader = new FileReader();
					reader.readAsDataURL(input.files[0]);
					this.fileDetails.file = input.files[0];
					this.fileDetails.present = true;
					this.fileDetails.flag = true;
					this.sourceKey = this.fileDetails.file;
				} else {
					this.filetype = false;
					this.fileDetails.size = false;
					this.fileDetails.file = "";
					this.fileDetails.present = false;
					this.fileDetails.fileName = "";
				}
			}
		},
		handleDrop(event) {
			console.log("Drop: " + event);
			event.preventDefault();
			const files = event.dataTransfer.files;
			if (files.length > 0) {
				const file = files[0];
				this.checkFile({ target: { files: [file] } });
			}
		},
		async uploadDocs() {
			try {
				this.$v.$touch();
				if (this.$v.$invalid || !this.fileDetails.present) {
					this.notUpload = !this.fileDetails.present;
					this.errorModal("Error", "Please fill all the required fields");
					return;
				}

				this.buttonLoader = true;
				this.notUpload = false;
				this.loading = true;
				if (!this.fileDetails.present) {
					this.fileDetails.flag = false;
					return;
				}

				var form = new FormData();
				let source = {
					sourceKeys: ["key"],
				};

				form.append("documentName", this.defineDocName);
				form.append("source", JSON.stringify(source));
				form.append("key", this.sourceKey);

				if (!this.otherModal) {
					form.append("tag", true);
					form.append("referenceID", this.defineDocReferenceID);
				} else {
					form.append("categoryID", this.categoryID);
				}

				const response = await postDocument(form);
				if (response.status == 200) {
					this.buttonLoader = false;
					this.notUpload = false;
					this.loading = false;
					this.$bvModal.hide("candidateUploadDocuments");
					this.successModal("Success", "Document uploaded successfully!");

					this.$emit("documentUploaded", {
						documentName: this.defineDocName,
					});
					if (!this.isLaptop) {
						this.$emit("updateDoc");
					}
					this.$forceUpdate();
					this.fileDetails = {
						file: "",
						fileName: "",
						present: false,
						flag: true,
					};
					this.defineDocName = "";
				} else if (response.status == 208) {
					this.buttonLoader = false;
					this.errorModal("Warning", "Document name already exists");
					this.loading = false;
				}
				this.$v.$reset();
			} catch (error) {
				this.buttonLoader = false;
				this.loading = false;
				throw error;
			}
		},
	},
};
</script>
<style scoped>
.loader-class-doc {
	height: 31px;
	width: 91.9px;
	opacity: 0.5;
}
.loader-pos-doc {
	position: absolute;
	top: -54px;
	z-index: 1;
	left: 0px;
}
.canDoc-modal-head {
	font-family: "Lato";
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
.canDoc-modal-label {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #344054;
}
.doc-modal-fields .form-control {
	/* width: 475px; */
	height: 41px;
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	padding: 10px 14px;
}
.doc-modal-fields .form-control::placeholder {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
}
.dragndrop-txt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
}

.px-5-query {
	padding: 15px 30px !important;
}

@media screen and (max-width: 990px) {
	.px-5-query {
		padding: 10px !important;
	}

	.upload-loader-pos-doc {
		left: 26px !important;
	}

	.upload-loader-class-doc {
		width: 145px !important;
	}
}

.browsefile-txt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #20639b;
}
.subtxt-uld-box {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 12px;
	text-align: center;
	color: #475467;
}
.uploaded-box {
	/* padding: 25px 76px; */
	width: 100%;
	height: 44px;
	background: #f6f9fb;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}
.err-txt-uploadfail {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 11px;
	/* identical to box height, or 11px */

	color: #eb0002;
}
</style>

<style>
.uld-dum {
	width: 22px;
	height: 22px;
}
.btn-sizes-web {
	width: 145px;
	height: 32px;
	margin-right: 10px;
}
.doc-modal-fields .form-control:disabled {
	background-color: #e9ecef;
	opacity: 0.6;
}
.upload-loader-class-doc {
	height: 31px;
	width: 92px;
	opacity: 0.5;
}
.upload-loader-pos-doc {
	position: absolute;
	top: -54px;
	z-index: 1;
	left: 2px;
}

.laptop-error-pos {
	position: absolute;
	left: 0px;
	bottom: -22px;
}
</style>
